<div class="inidicator-status-filter-container">
    <button class="filter-current-element" (mouseenter)="showPanel(true)" (mouseleave)="showPanel(false)">
        <span class="flag"
            [ngClass]="{'flag-all' : currentValue === 'all','flag-on' : currentValue === 'on','flag-off' : currentValue === 'off'}"></span>
    </button>
    <div class="filter-items-container" (mouseenter)="showPanel(true)" (mouseleave)="showPanel(false)"
        *ngIf="isPanelVisible === true">
        <ul class="filter-items">
            <!-- wszystkie -->
            <li class="filter-item" [ngClass]="{'selected1' : currentValue==='all'}" (click)="onSelect('all')">
                <span class="flag-container">
                    <span class="flag flag-all"></span>
                </span>
                <span class="flag-label">{{'labels.all' | translate | titlecase}}</span>
            </li>
            <!-- wlaczone -->
            <li class="filter-item" [ngClass]="{'selected1' : currentValue==='on'}" (click)="onSelect('on')">
                <span class="flag-container">
                    <span class="flag flag-on"></span>
                </span>
                <span class="flag-label">{{'labels.on' | translate | titlecase}}</span>
            </li>
            <!-- wylaczone -->
            <li class="filter-item" [ngClass]="{'selected1' : currentValue==='off'}" (click)="onSelect('off')">
                <span class="flag-container">
                    <span class="flag flag-off"></span>
                </span>
                <span class="flag-label">{{'labels.off' | translate | titlecase}}</span>
            </li>
        </ul>
    </div>
</div>
